/**
 * Order payload builder – skapar OrderPayload för submit.
 */

import { OrderContact, OrderPayload } from 'src/@types/customerPortalApi';
import { GroupedService } from '../../types/service.types';

/**
 * Builds the order payload for backend submission from selected grouped services.
 * Extracts container references (id + serviceNumber) based on selected quantity.
 *
 * @param selectedServices - GroupedServices with selectedQuantity > 0
 * @param date - Selected date (YYYY-MM-DD) or null for earliest possible
 * @param contact - Contact information
 * @param loadingInformation - Comment/message as string
 * @returns Order payload ready for POST request
 */
export function buildOrderPayload(
  selectedServices: GroupedService[],
  date: string | null,
  contact: OrderContact,
  loadingInformation: string
): OrderPayload {
  const containers = selectedServices.flatMap((grouped) => {
    const validQuantity = Math.min(Math.max(0, grouped.selectedQuantity), grouped.maxQuantity);

    if (validQuantity <= 0) {
      return [];
    }

    return grouped.containers.slice(0, validQuantity);
  });

  return {
    date,
    contact,
    loadingInformation,
    containers,
  };
}
